import { addDeviceClasses } from './utils/add-device-classes'
import { updateFontSize } from './utils/update-font-size'
import { setScreenSize } from './utils/breakpoints'
import { initOurEvents } from './blocks/our-events'
import { wrapIframes } from "./utils/wrap-iframes"
import { initResponsiveTables } from "./utils/responsive-tables"
import { reloadIfScreenSizeInOtherBreakpoint } from "./utils/reload-if-screen-size-in-other-breakpoint"

let defaultFontSize = 16
let smallScreenHeightFontSize = 16
let maxFontSize = 99

updateFontSize(defaultFontSize, smallScreenHeightFontSize, maxFontSize)
addDeviceClasses()
wrapIframes()
initResponsiveTables()


$(window).on('resize', function (){

  updateFontSize(defaultFontSize, smallScreenHeightFontSize, maxFontSize)

  setScreenSize()

  initOurEvents()

  reloadIfScreenSizeInOtherBreakpoint()

})
